// extracted by mini-css-extract-plugin
export var quantityInput = "_fd-0";